import { render, staticRenderFns } from "./LaudoAvaliacaoAreaProdutiva.vue?vue&type=template&id=5831c10e&scoped=true&lang=pug"
import script from "./LaudoAvaliacaoAreaProdutiva.vue?vue&type=script&lang=js"
export * from "./LaudoAvaliacaoAreaProdutiva.vue?vue&type=script&lang=js"
import style0 from "./LaudoAvaliacaoAreaProdutiva.vue?vue&type=style&index=0&id=5831c10e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5831c10e",
  null
  
)

export default component.exports